import React from 'react'

import { Button, ButtonProps, makeStyles } from '@material-ui/core'

type StyleProps = {
    disabled?: boolean
}

const useStyles = makeStyles(() => ({
    root: {
        background: '#FFF !important',
        fontWeight: 500,
        fontSize: 14,
        letterSpacing: 1.25,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        boxShadow: ({ disabled }: StyleProps) =>
            disabled ? 'none' : 'rgba(0, 0, 0, 0.4)',
        color: ({ disabled }: StyleProps) => (disabled ? '#BDBDBD' : '#090C10'),
        '& svg': {
            color: ({ disabled }: StyleProps) =>
                disabled ? '#BDBDBD' : '#090C10'
        }
    }
}))

export type WhiteButtonProps = ButtonProps

export const WhiteButton = ({
    children,
    disabled,
    ...props
}: WhiteButtonProps) => {
    const classes = useStyles({ disabled })

    return (
        <Button {...props} className={classes.root} color="default">
            {children}
        </Button>
    )
}
